import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { videosApi } from "@/api/videos.ts";
import { PageContainer, TfSpinner } from "@/components/v2/primitives.tsx";
import { EngineReview } from "@/components/engine/EngineReview.tsx";
import { RetiredLegacyVideo } from "@/components/engine/RetiredLegacyVideo.tsx";

/**
 * Session 4 K2: a video made by the engine (`runId` set) is reviewed from its run — EngineReview reads the run's
 * filmstrip and every action is a gate decision. (TF3-3) A legacy video (no run): its
 * steps are retired; RetiredLegacyVideo points to its own page.
 */
export function ScriptReviewPage() {
  const { id } = useParams<{ id: string }>();
  const q = useQuery({ queryKey: ["video", id], queryFn: () => videosApi.get(id!), enabled: !!id });
  if (q.data?.video.runId) return <PageContainer><EngineReview videoId={id!} /></PageContainer>;
  if (q.isLoading) return <PageContainer><TfSpinner /></PageContainer>;
  return <RetiredLegacyVideo videoId={id!} />;
}
